import React from 'react';
import { 
  Box, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  IconButton, 
  Typography,
  Chip
} from '@mui/material';
import { Visibility, Edit, Delete } from '@mui/icons-material';

const PrincipalTable = ({ principals, onEdit, onDelete }) => {
  if (principals.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body2" sx={{ color: 'grey.500' }}>
          There's no records to display
        </Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ boxShadow: 'none', border: 1, borderColor: 'grey.200' }}>
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: 'grey.50' }}>
            <TableCell sx={{ fontWeight: 600 }}>First Name</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Last Name</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Title</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>% of Ownership</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Authorized Signer</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Manager / Controller</TableCell>
            <TableCell sx={{ fontWeight: 600 }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {principals.map((principal) => (
            <TableRow key={principal.id} hover>
              <TableCell>{principal.firstName}</TableCell>
              <TableCell>{principal.lastName}</TableCell>
              <TableCell>{principal.title}</TableCell>
              <TableCell>{principal.ownershipPercent}%</TableCell>
              <TableCell>
                <Chip
                  label={principal.authorizedSigner ? 'Yes' : 'No'}
                  color={principal.authorizedSigner ? 'success' : 'default'}
                  size="small"
                  variant="outlined"
                />
              </TableCell>
              <TableCell>
                <Chip
                  label={principal.managerController ? 'Yes' : 'No'}
                  color={principal.managerController ? 'success' : 'default'}
                  size="small"
                  variant="outlined"
                />
              </TableCell>
              <TableCell>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  {/* <IconButton
                    size="small"
                    sx={{ 
                      bgcolor: 'green.100', 
                      color: 'green.600',
                      '&:hover': { bgcolor: 'green.200' }
                    }}
                  >
                    <Visibility fontSize="small" />
                  </IconButton> */}
                  <IconButton
                    size="small"
                    onClick={() => onEdit(principal)}
                    sx={{ 
                      bgcolor: 'green.100', 
                      color: 'green.600',
                      '&:hover': { bgcolor: 'green.200' }
                    }}
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={() => onDelete(principal.id)}
                    sx={{ 
                      bgcolor: 'red.100', 
                      color: 'red.600',
                      '&:hover': { bgcolor: 'red.200' }
                    }}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PrincipalTable;
